import axios from 'axios';
import { IResponse } from '~/services/api/types';
import { INote, INotesListFilters } from './types';

const apiUrl = 'notes';

export const getList = (params: INotesListFilters): IResponse<INote[]> =>
  axios({
    method: 'get',
    url: apiUrl,
    params,
  });

export const get = (id: number): IResponse<INote> =>
  axios({
    method: 'get',
    url: `${apiUrl}/${id}`,
  });

export const create = (patientId: number, data: INote): IResponse<INote> =>
  axios({
    method: 'post',
    url: apiUrl,
    data,
    params: {
      patientId,
    },
  });

export const update = (data: INote): IResponse<INote> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const remove = (id: number): IResponse<void> =>
  axios({
    method: 'delete',
    url: `${apiUrl}/${id}`,
  });
